var map = {
	"./dialogs/dialogs.ar_AR.js": 61353,
	"./dialogs/dialogs.en_US.js": 28081,
	"./dialogs/dialogs.fr_FR.js": 51761,
	"./dialogs/dialogs.jp_JP.js": 10584,
	"./dialogs/dialogs.js": 12010,
	"./dialogs/dialogs.ko_KR.js": 89442,
	"./dialogs/dialogs.ru_RU.js": 61349,
	"./dialogs/dialogs.zh_CN.js": 46502,
	"./fonts.js": 13968,
	"./game/game.ar_AR.js": 18344,
	"./game/game.en_US.js": 43415,
	"./game/game.fr_FR.js": 44859,
	"./game/game.jp_JP.js": 95392,
	"./game/game.js": 96246,
	"./game/game.ko_KR.js": 74262,
	"./game/game.ru_RU.js": 32669,
	"./game/game.zh_CN.js": 18856,
	"./icons/icons.js": 4651,
	"./langs.js": 25588,
	"./loading/loading.ar_AR.js": 50926,
	"./loading/loading.en_US.js": 41525,
	"./loading/loading.fr_FR.js": 52224,
	"./loading/loading.jp_JP.js": 29322,
	"./loading/loading.js": 50878,
	"./loading/loading.ko_KR.js": 19329,
	"./loading/loading.ru_RU.js": 26408,
	"./loading/loading.zh_CN.js": 93062,
	"./map/map.ar_AR.js": 77938,
	"./map/map.en_US.js": 9018,
	"./map/map.fr_FR.js": 32514,
	"./map/map.jp_JP.js": 48545,
	"./map/map.js": 27818,
	"./map/map.ko_KR.js": 71477,
	"./map/map.ru_RU.js": 36986,
	"./map/map.zh_CN.js": 31481,
	"./menu/menu.ar_AR.js": 71098,
	"./menu/menu.en_US.js": 33211,
	"./menu/menu.fr_FR.js": 95424,
	"./menu/menu.jp_JP.js": 73548,
	"./menu/menu.js": 65889,
	"./menu/menu.ko_KR.js": 10224,
	"./menu/menu.ru_RU.js": 85320,
	"./menu/menu.zh_CN.js": 45308,
	"./rotatescreen/rotatescreen.ar_AR.js": 70668,
	"./rotatescreen/rotatescreen.en_US.js": 16107,
	"./rotatescreen/rotatescreen.fr_FR.js": 22428,
	"./rotatescreen/rotatescreen.jp_JP.js": 63409,
	"./rotatescreen/rotatescreen.js": 62030,
	"./rotatescreen/rotatescreen.ko_KR.js": 90345,
	"./rotatescreen/rotatescreen.ru_RU.js": 22406,
	"./rotatescreen/rotatescreen.zh_CN.js": 96428,
	"./scenes/scenes.ar_AR.js": 87290,
	"./scenes/scenes.en_US.js": 49626,
	"./scenes/scenes.fr_FR.js": 71352,
	"./scenes/scenes.jp_JP.js": 21503,
	"./scenes/scenes.js": 73344,
	"./scenes/scenes.ko_KR.js": 82074,
	"./scenes/scenes.mobile.js": 8444,
	"./scenes/scenes.ru_RU.js": 9480,
	"./scenes/scenes.zh_CN.js": 9395,
	"./sounds/sounds.js": 85428,
	"./splashscreen/splashscreen.ar_AR.js": 17123,
	"./splashscreen/splashscreen.en_US.js": 82671,
	"./splashscreen/splashscreen.fr_FR.js": 51779,
	"./splashscreen/splashscreen.jp_JP.js": 65977,
	"./splashscreen/splashscreen.js": 4781,
	"./splashscreen/splashscreen.ko_KR.js": 95654,
	"./splashscreen/splashscreen.mobile.js": 79383,
	"./splashscreen/splashscreen.ru_RU.js": 76906,
	"./splashscreen/splashscreen.zh_CN.js": 21657,
	"./tutorial/tutorial.ar_AR.js": 52849,
	"./tutorial/tutorial.en_US.js": 6995,
	"./tutorial/tutorial.fr_FR.js": 75054,
	"./tutorial/tutorial.jp_JP.js": 23083,
	"./tutorial/tutorial.js": 49741,
	"./tutorial/tutorial.ko_KR.js": 1283,
	"./tutorial/tutorial.mobile.en_US.js": 23654,
	"./tutorial/tutorial.mobile.fr_FR.js": 6478,
	"./tutorial/tutorial.mobile.js": 82222,
	"./tutorial/tutorial.ru_RU.js": 9048,
	"./tutorial/tutorial.zh_CN.js": 85798,
	"./videos/videos.ar_AR.js": 74176,
	"./videos/videos.en_US.js": 94709,
	"./videos/videos.fr_FR.js": 41342,
	"./videos/videos.jp_JP.js": 66647,
	"./videos/videos.js": 94487,
	"./videos/videos.ko_KR.js": 18071,
	"./videos/videos.ru_RU.js": 71001,
	"./videos/videos.zh_CN.js": 34215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87134;